import { getOAuthErrorMessage } from '@/features/core/util/oauth-error-message';
import { getRxjsHttpErrorCode, RxjsHttpErrorResponseBody } from '@/features/core/util/rxjs-http-error-response';
import { GenericNotificationApiAuthenticationType } from '@/types/generic-notification-api.model';

const LABEL_ALREADY_EXISTS_MESSAGE = 'Eine Generic Notification API mit diesem Beschriftung existiert bereits.';

const VENDOR_ENDPOINT_ERROR_MESSAGES: Record<string, string> = {
  vendor_endpoint_unauthorized: 'Bitte geben Sie die korrekte Endpoint des Zielsystems.',
  vendor_endpoint_forbidden: 'Der Zugriff auf den angegebenen Endpoint des Zielsystems ist verboten.',
};

const CREDENTIAL_ERROR_MESSAGES: Record<string, string> = {
  invalid_uname_password_endpoint:
    'Die Authentifizierung ist fehlgeschlagen. Bitte überprüfen Sie den Benutzernamen/Passwort oder den Endpunkt des Zielsystems.',
  invalid_pat_endpoint: 'Bitte geben Sie einen gültigen Zugriffstoken oder Endpoint des Zielsystems an.',
};

/** Returns an empty string for unknown errors so callers can apply their own fallback message. */
export function getGenericNotificationApiSaveErrorMessage(
  status: number | null,
  responseBody: RxjsHttpErrorResponseBody | null,
  authenticationType: GenericNotificationApiAuthenticationType | undefined,
): string {
  if (status === 409 && responseBody?.error?.message === 'label_already_exists') {
    return LABEL_ALREADY_EXISTS_MESSAGE;
  }

  const errorCode = getRxjsHttpErrorCode(responseBody);

  if (errorCode === undefined) {
    return '';
  }

  if (authenticationType === 'oauth_client_credentials') {
    const oauthMessage = getOAuthErrorMessage(responseBody);
    if (oauthMessage !== '') {
      return oauthMessage;
    }
  } else if (authenticationType === 'basic_auth' || authenticationType === 'pat') {
    if (CREDENTIAL_ERROR_MESSAGES[errorCode] !== undefined) {
      return CREDENTIAL_ERROR_MESSAGES[errorCode];
    }
  }

  return VENDOR_ENDPOINT_ERROR_MESSAGES[errorCode] ?? '';
}
